module.exports = "<div class=\"exHeader\"></div>\n<div id=\"container\">\n  <h2> Hilfe: {{get_title()}}</h2>\n  <img src=\"{{get_helperUrl()}}\" />\n</div>\n"